export default "清算和易货中心模式允许成员使用我们的虚拟货币购买商品和服务。这是一个集中结算和交易录入的过程。\n\n在交易中，清算是必要的，因为交易的速度远远快于完成基础交易的周期时间。\n";